import Page from '@/components/ui/Page'
import Title from '@/components/ui/Title'

const Resume = () => {
  return (
    <Page className="text-center overflow-y-auto">
      <Title className="pb-8" text="Resume" />
      <object
        data="/resume/resume.pdf"
        type="application/pdf"
        className="h-screen w-full"
      >
        Resume failed to load
      </object>
    </Page>
  )
}

export default Resume
